import { statsAPI } from "utils/apiClients";

// ✅ Generic function for GET requests (pagination supported)
export const apiGet = async (url, params = {}) => {
  if (params.pageNo !== undefined) {
    params._page = params.pageNo;
    delete params.pageNo;
  }
  if (params.pageSize !== undefined) {
    params._per_page = params.pageSize;
    delete params.pageSize;
  }
    const queryParams = new URLSearchParams(params).toString(); // Convert params to query string
    const response = await statsAPI.get(`${url}${queryParams && "?"}${queryParams}`); // Append manually
    if (response?.data) {
     
      return response?.data;

      
    } else {
      return transformErrorResponse;
    }
  };
  
  
  

// ✅ Generic function for POST requests
export const apiPost = async (url, data) => {
  const response = await statsAPI.post(url, data);
  if (response.data) {
    return response?.data;
  }
  else {
    return transformErrorResponse

  }
};



export const apiUpdate = async (url, data) => {
  console.log("Updating with data:", data);
  const response = await statsAPI.put(url, data); // ✅ URL now includes `id`
  if (response.data) {
    return response?.data;
  } else {
    return transformErrorResponse();
  }
};

export const apiDelete = async (url) => {
  console.log("Deleting from URL:", url);
  const response = await statsAPI.delete(url); // ✅ URL should have `id`
  if (response.status === 200 || response.status === 204) {
    return response?.data;
  } else {
    return transformErrorResponse();
  }
};




  
  const transformErrorResponse = (statusCode = 400, errorMessage = "Sorry, Something went wrong") => {
    return {
      id: null,
      isSuccess: false,
      statusCode: statusCode,
      info: {
        info: null,
        stackTrace: null
      },
      data: null,
      errors: [
        {
          statusCode: 2, // This seems to be a fixed internal status code for errors
          errorMessageEn: errorMessage
        }
      ],
      totalPages: 0
    };
  };
  
  
